import React from "react";
import "./styles.scss";
import MeatBallsLoader from "../MeatBallsLoader";

const CustomConnectCard = ({
  cardDescription,
  cardImage,
  buttonText,
  onConnect,
  connectUrl,
  loading,
  loadingText,
}) => {
  return (
    <div className="bank-connect-card">
      <div className="card-content">
        {loading ? (
          <MeatBallsLoader loadingText={loadingText} />
        ) : (
          <>
            <img src={cardImage} alt={"Bank Logo"} className="bank-logo" />
            <p className="description">{cardDescription}</p>
            <a href={connectUrl}>
              <button className="connect-button" onClick={onConnect}>
                {buttonText}
              </button>
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomConnectCard;
